import { render, staticRenderFns } from "./IntervieweeList.vue?vue&type=template&id=2800ffb8&scoped=true&"
import script from "./IntervieweeList.vue?vue&type=script&lang=js&"
export * from "./IntervieweeList.vue?vue&type=script&lang=js&"
import style0 from "./IntervieweeList.vue?vue&type=style&index=0&id=2800ffb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800ffb8",
  null
  
)

export default component.exports